export enum CountryCodeEnum {
  ma = 'ma',
  ae = 'ae',
  sa = 'sa',
  eg = 'eg',
  bh = 'bh',
  lb = 'lb',
  qa = 'qa',
}
